import { createContext, useContext } from 'react';
import { SelectedSkuContextInterface } from 'types/SelectedSkuTypes';

export const SelectedSkuContext = createContext<SelectedSkuContextInterface | null>(null);

export const useSelectedSkuContext = () => useContext(SelectedSkuContext) as SelectedSkuContextInterface;
